import type { APIData } from 'webapp-types';

import type MetricLimitationCumulative from 'webapp/models-custom/metric-limitation/cumulative';
import type MetricLimitationGranulation from 'webapp/models-custom/metric-limitation/granulation';

// Base class - can be range, granulation, cumulative
// rawData can be empty (usually when metric limitations are not loaded yet)
// rawData empty still allows item to be selected
// for rawData example, check models-custom/metric-limitations, fn updateLimitations

export default abstract class MetricLimitationBase<
	RawData extends APIData.Metrics.Limitation = APIData.Metrics.Limitation,
> {
	id: string;
	rawData: RawData | null;
	isParentDisabled: boolean;

	childLimitations: (MetricLimitationCumulative | MetricLimitationGranulation)[] = [];

	abstract get disabled(): boolean;

	abstract get infoText(): string;

	constructor(id: string, rawData?: RawData | null, isParentDisabled = false) {
		this.id = id;
		this.rawData = rawData || null;
		this.isParentDisabled = isParentDisabled;
	}

	get isPaidLimitation(): boolean {
		let isPaid = false;

		if (this.rawData && this.disabled) {
			if (this.getLimitationType(this.rawData.info) === 'paid') {
				isPaid = true;
			} else {
				// could happen that range is not disabled by itself, but f.ex "Total" granulation is
				// then we need to show the limitation on range when isNumber is chosen
				// all limitations that are not base constraints must be paid limitations
				const notBaseConstraintLimitations = this.childLimitations.filter(
					(l) => !l.unsupportedBaseConstraint,
				);
				isPaid =
					!!notBaseConstraintLimitations.length &&
					notBaseConstraintLimitations.filter((item) => !item.isPaidLimitation).length ===
						0;
			}
		}

		return isPaid;
	}

	get isDisabledForPaymentReasons(): boolean {
		return this.isPaidLimitation; // // so we can call mmMetricsService.getLimitationInfoForDateRangeOrGranulation with this model
	}

	private getLimitationType(rawDataInfo?: APIData.Metrics.Limitation['info']): string {
		let type = '';
		if (rawDataInfo?.type && rawDataInfo.type >= 600 && rawDataInfo.type < 700) {
			type = 'paid';
		}
		return type;
	}
}
